import type { OrganisationTeamFilters } from "@/types/organisation-team"

function teamListFilters(query: string): OrganisationTeamFilters {
  const search = query.trim()

  return search ? { search } : {}
}

export { teamListFilters }
